import React from 'react'
import PropTypes from 'prop-types'

import { get, reject, sortBy, isUndefined } from 'lodash'

import Year from './Year'

import './index.scss'

const MAX_APPLICANT_STEP_SIZE = 10

export default class HistoricalApplicationsChart extends React.Component {
  static propTypes = {
    years: PropTypes.arrayOf(
      PropTypes.shape({
        GraduationYear: PropTypes.number.isRequired,
        NumApplicants: PropTypes.number.isRequired,
        PctAccepted: PropTypes.number.isRequired,
        PctEnrolled: PropTypes.number.isRequired,
      }),
    ),
  }
  static defaultProp = {
    years: [],
  }
  state = {
    maxApplicants: 1,
  }
  componentDidMount() {
    this.setMaxApplicants()
  }
  setMaxApplicants() {
    const highest = this.props.years.reduce((result, o) => Math.max(result, o.NumApplicants), 0)
    let maxApplicants = Math.ceil(highest / MAX_APPLICANT_STEP_SIZE) * MAX_APPLICANT_STEP_SIZE
    if (maxApplicants === MAX_APPLICANT_STEP_SIZE) {
      maxApplicants = highest
    }
    this.setState({ maxApplicants })
  }
  render() {
    const { maxApplicants } = this.state
    let years = reject(this.props.years, (year) => year.NumApplicants === 0)
    years = sortBy(years, 'GraduationYear')
    return (
      maxApplicants > 0 && (
        <div className="historical-applications-chart-comp">
          <ul className="label-column">
            <li className="data-row applicants">Applicants</li>
            <li className="data-row acceptance">Acceptance</li>
            <li className="data-row enrollment">Enrollment</li>
          </ul>
          <div className="chart-area">
            <div className="y-axis-left">
              <span>{maxApplicants}</span>
              <span>0</span>
            </div>
            <div className="chart-columns">
              {years.map((year, idx) => {
                const prev = years[idx - 1]
                return (
                  <div
                    key={idx}
                    className="year"
                  >
                    <Year
                      year={year.GraduationYear}
                      hasPrev={!isUndefined(prev)}
                      maxApplicants={maxApplicants}
                      applicantsCount={year.NumApplicants}
                      acceptanceRate={year.PctAccepted}
                      enrollmentRate={year.PctEnrolled}
                      prevApplicantsCount={get(prev, 'NumApplicants')}
                      prevAcceptanceRate={get(prev, 'PctAccepted')}
                      prevEnrollmentRate={get(prev, 'PctEnrolled')}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      )
    )
  }
}
